import React, { useEffect } from 'react';
import { ConfigType } from '@/types/configType';
import { EnvironmentType } from '@/types/environmentType';
import { useState } from 'react';
import useConfig from '@/hooks/useConfig';
import qs from 'qs';
import { useLocation } from 'react-router-dom';
import { useSpecUrls } from '@/context/SpecUrlsContext';
import SelectBox from '@/components/SelectBox';
import SwaggerLoader from '@/components/SwaggerLoader';

interface SwaggerProps {
  environment: EnvironmentType;
}

function Swagger({ environment }: SwaggerProps) {
  const { specUrls, setSpecUrls, getSpecUrl } = useSpecUrls();
  const getConfig = useConfig({ type: environment.type, defaultUrl: environment.defaultUrl });

  const location = useLocation();
  const [activeSpec, setActiveSpec] = useState<ConfigType>({ url: '', name: '', group: '' });

  const init = async () => {
    const specUrls = await getConfig();
    setSpecUrls(specUrls);

    const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });
    const name = String(queryParams.activeName ?? environment.defaultName);
    const specUrl = getSpecUrl(specUrls, name);
    if (specUrl) {
      setActiveSpec(specUrl);
    }
  };

  useEffect(() => {
    init();
  }, [environment, location.search]);

  return (
    <>
      <SelectBox data={specUrls} name={activeSpec.name} defaultUrl={environment.defaultUrl} />
      {activeSpec.url && <SwaggerLoader data={activeSpec} />}
      {/*<Modal host={currHostName} isVisible={modalState} setModalState={setModalState} />*/}
    </>
  );
}

export default Swagger;
